<script>
export default {
  name: "MobileMappingFaq"
}
</script>

<template>
<div>
  <div class="h2 mb-5 new-font-medium">FAQ</div>
  <p>Hier finden Sie Antworten auf die häufigsten Fragen rund um das Mobile Mapping bei der NEW Netz GmbH: von der Technik über Vorteile bis hin zum Datenschutz.</p>
  <v-expansion-panels accordion multiple>
    <v-expansion-panel>
      <v-expansion-panel-header class="expansion-panel-header-custom">
        Wie funktioniert Mobile Mapping?
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        Mobile Mapping erfasst Straßen und Infrastruktur automatisch mit einem Fahrzeug und erstellt daraus hochgenaue 3D‑Daten und Bilder.
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel>
      <v-expansion-panel-header class="expansion-panel-header-custom">
        Wie wird beim Mobile Mapping der Datenschutz gewährleistet?
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        Infos zum Datenschutz finden Sie unter:
        <a target='_blank' href='https://datenschutz.new.de/kommunalportal'><v-icon color="primary" small>mdi-open-in-new</v-icon>Datenschutzinformationen</a>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel>
      <v-expansion-panel-header class="expansion-panel-header-custom">
        Welchen Mehrwert bietet das System für Kommunen?
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <ul>
          <li>Mobile Mapping gibt Ihnen ein vollständiges digitales Abbild aller Straßen und das jederzeit abrufbar vom Schreibtisch aus</li>
          <li>Sie erkennen Schäden frühzeitig und können Sanierungen gezielt und wirtschaftlich planen</li>
          <li>Es spart Zeit, reduziert Außentermine und erhöht gleichzeitig die Qualität Ihrer Entscheidungen</li>
        </ul>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel>
      <v-expansion-panel-header class="expansion-panel-header-custom">
        Wie präzise ist die Datenerfassung beim Mobile Mapping?
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        Wir garantieren eine 3D Genauigkeit (X-,Y-, Z-Koordinate) unterhalb 10 cm
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel>
      <v-expansion-panel-header class="expansion-panel-header-custom">
        Was ist mit den Daten noch möglich?
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        KI-basierte Auswertung, z.B. Straßenzustandsbewertung, Straßeninventar, Analyse des Straßenbegleitgrüns (Baumkataster) uvm.
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</div>
</template>

<style scoped>

</style>